import React, { useRef } from 'react'
import { StyledInputGroup } from './Form.ui'
import { ReactComponent as CameraIcon } from '../assets/icons/camera.svg'
const calculateCommonDivisor = (a, b) =>
    b === 0 ? a : calculateCommonDivisor(b, a % b)

const InputImage = (props) => {
    const imageRef = useRef()
    const {
        width = '170px',
        height = '170px',
        value,
        onChange,
        maxImageWidth = 200,
        maxImageHeight = 200,
        noEdit,
    } = props
    if (noEdit && !props.value) {
        return null
    }
    return (
        <StyledInputGroup
            {...props}
            style={{ height: '10rem', ...props.style }}
            onClick={() => {
                imageRef?.current?.click()
            }}
        >
            {props.value ? (
                <img
                    src={props.value}
                    alt="post"
                    style={{
                        cursor: 'pointer',
                        border: 'var(--borders-main)',
                        borderRadius: 'var(--borderRadius-sm)',
                        overflow: 'hidden',
                        width: 'fit-content',
                        minHeight: '8rem',
                        minWidth: '5rem',
                        background: 'var(--colors-grays-0)',
                    }}
                />
            ) : (
                <CameraIcon
                    style={{
                        cursor: 'pointer',
                        heigh: '100%',
                        width: 'auto',
                        padding: '1rem',
                        border: 'var(--borders-main)',
                        borderRadius: 'var(--borderRadius-sm)',
                        background: 'var(--colors-grays-20)',
                    }}
                />
            )}
            {/* <input
                type="text"
                onChange={props.onChange}
                value={value}
                title={props.title}
                name={props.name}
            /> */}
            <input
                type="file"
                ref={imageRef}
                accept="image/*"
                style={{ display: 'none' }}
                name={props.name}
                onChange={(e) => {
                    const file = imageRef?.current?.files?.[0]
                    if (!file) return
                    const img = new Image()
                    img.src = window.URL.createObjectURL(file)
                    img.onload = () => {
                        const imgWidth = img.naturalWidth
                        const imgHeight = img.naturalHeight
                        window.URL.revokeObjectURL(img.src)
                        // if (
                        //     imgWidth <= maxImageWidth &&
                        //     imgHeight <= maxImageHeight
                        // ) {
                        //     const reader = new FileReader()
                        //     reader.onload = (ev) => {
                        //         if (ev?.target?.result && onChange && file) {
                        //             const blob = new Blob(
                        //                 [new Uint8Array(ev.target.result)],
                        //                 { type: file.type }
                        //             )
                        //             onChange(blob)
                        //         }
                        //     }
                        //     if (imageRef?.current?.files?.[0]) {
                        //         reader.readAsArrayBuffer(
                        //             imageRef.current.files[0]
                        //         )
                        //     }
                        // } else {
                        const canvas = document.createElement('canvas')
                        const ctx = canvas.getContext('2d')
                        const ratio = Math.min(
                            maxImageWidth / imgWidth,
                            maxImageHeight / imgHeight
                        )
                        console.log[{ ratio }]
                        canvas.width = imgWidth * ratio
                        canvas.height = imgHeight * ratio
                        canvas.style.minWidth = canvas.width + 'px'
                        canvas.style.minHeight = canvas.height + 'px'
                        ctx?.drawImage(img, 0, 0, canvas.width, canvas.height)
                        if (onChange && file) {
                            const dataURL = canvas.toDataURL()
                            onChange(dataURL)
                        }
                        // }
                    }
                }}
            />
        </StyledInputGroup>
    )
}
export default InputImage
